import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faPhone, faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';

const WaveContainer = styled.div`
  position: absolute;
  top: -100px;
  left: 0;
  width: 100%;
  height: 100px;
  overflow: hidden;
  line-height: 0;
  transform: rotate(180deg);

  svg {
    background: ${props => props.theme.colors.primary};
    position: relative;
    display: block;
    width: calc(100% + 1.3px);
    height: 100px;
  }

  .elementor-shape-fill {
    fill: ${props => props.theme.colors.background};;
  }
`;

const FooterSection = styled.footer`
  background: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.light};
  padding: 4rem 0 2rem 0;
  position: relative;
  margin-top: 100px;
  
  &::before {
    content: '';
    position: absolute;
    top: -64px;
    left: 50.12%;
    transform: translateX(-50%);
    width: 85px;
    height: 80px;
    background: url('/images/Tbh-logo-3d.png') center/cover no-repeat;
    border-radius: 50%;
    z-index: 2;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 2fr 1fr ;
  gap: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const Column = styled.div`
  h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    font-weight: 600;
  }
  
  p {
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }
`;



const ContactInfo = styled.div`
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: rgba(255, 255, 255, 0.8);
  
  svg {
    font-size: 1.2rem;
  }
  
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  
  @media (max-width: 768px) {
    justify-content: center;
  }
  
  a {
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.colors.light};
    transition: all 0.3s ease;
    
    &:hover {
      background: ${props => props.theme.colors.light};
      color: ${props => props.theme.colors.primary};
    }
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.8);
`;

function Footer() {
  return (
    <FooterSection>
      <WaveContainer>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none">
	<path className="elementor-shape-fill" d="M806,94.7C619.5,90,500,20.3,500,1.7c-1,18.6-117.5,88.3-306,93C92,97.2,0,97.9,0,97.9v-0l0,0v2.3h1000v-2.3 C1000,97.7,920.3,97.6,806,94.7z M350,65.1L350,65.1L350,65.1L350,65.1z"></path>
</svg>
      </WaveContainer>
      <Container>
        <Column>
          <h3>The Big Heart</h3>
          <p>A big heart beats strongest when many hands work together.</p>
          <SocialLinks>
            <a href="https://facebook.com/association.tbh" aria-label="Facebook"><FontAwesomeIcon icon={faFacebookF} /></a>
            <a href="https://twitter.com/AssociationTbh" aria-label="Twitter"><FontAwesomeIcon icon={faTwitter} /></a>
            <a href="https://www.instagram.com/association.tbh_" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} /></a>
            <a href="https://www.linkedin.com/company/association-tbh" aria-label="LinkedIn"><FontAwesomeIcon icon={faLinkedinIn} /></a>
          </SocialLinks>
        </Column>
        
        {/* <Column>
          <h3>Our Services</h3>
          <Links>
            <li><a href="#">Home</a></li>
            <li><a href="#">About Us</a></li>
            <li><a href="#">Events</a></li>
            <li><a href="#">Blog</a></li>
          </Links>
        </Column>
        
        <Column>
          <h3>Quick Link</h3>
          <Links>
            <li><a href="#">Knowledge Base</a></li>
            <li><a href="#">Hire An Expert</a></li>
            <li><a href="#">FAQ</a></li>
            <li><a href="#">Contact</a></li>
          </Links>
        </Column> */}
        
        <Column>
          <h3>Contact Us</h3>
          <ContactInfo>
            <FontAwesomeIcon icon={faPhone} />
            +212 777794712
          </ContactInfo>
          <ContactInfo>
            <FontAwesomeIcon icon={faEnvelope} />
            asso.thebigheart@tbh.ma
          </ContactInfo>
          <ContactInfo>
            <FontAwesomeIcon icon={faLocationDot} />
            Hay Hassani, Casablanca
          </ContactInfo>
        </Column>
      </Container>
      
      <Copyright>
        Copyright © {new Date().getFullYear()} TBH All Rights Reserved
      </Copyright>
    </FooterSection>
  );
}

export default Footer;
